// Checks the Version of the app, if doesn't match is removes all localstorage and have them sign in again
export const checkVersion = async () => {
    try {
      const currentVersion = localStorage.getItem("appVersion");
      const response = await fetch("/version.json");
      const data = await response.json();
  
      if (data.version !== currentVersion) {
        localStorage.clear();
        localStorage.setItem("appVersion", data.version);
        window.location.reload(true);
      }
    } catch (error) {
      console.error("Failed to check version:", error);
    }
  };
  